angular.module("survey").directive("ratingGroup", [ratingGroup])

function ratingGroup() {
  return {
    scope: {
      ngModel: "=",
      size: "@",
      color: "@"
    },
    bindToController: true,
    controllerAs: "ratingGroup",
    template: `<div ng-repeat="i in ratingGroup.values"
                    ng-click="ratingGroup.rate(i)"
                    ng-mouseover="ratingGroup.mouseover(i)"
                    ng-mouseout="ratingGroup.mouseout(i)"
                    class="star-wrapper">
                  <img ng-src="/static/img/stars/{{ ratingGroup.color }}_{{ ratingGroup.isFull(i) ? 'full' : 'empty' }}.png" draggable="false">
                </div>`,
    controller: function() {
      var vm = this;
      
      // populate array of values
      vm.values = [];
      for (var i = 1; i <= vm.size; i++) {
        vm.values.push(i);
      }

      // preload filled image
      var filled = (new Image()).src = `/static/img/stars/${vm.color}_full.png`;
      
      vm.rate = function(value) {
        vm.ngModel = value;
      }
      vm.mouseover = function(value) {
        vm.hovering = value;
      }
      vm.mouseout = function(value) {
        vm.hovering = undefined;
      }
      vm.isFull = function(value) {
        if (vm.hovering) return vm.hovering >= value;
        else if (vm.ngModel) return vm.ngModel >= value;
        else return false;
      }
    }
  }
}